import _typeof from "@babel/runtime/helpers/typeof";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";

(function () {
  var enterModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).enterModule;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { Component } from 'react';
import style from './TraceLine.css';
export var TraceLine =
/*#__PURE__*/
function (_Component) {
  _inherits(TraceLine, _Component);

  function TraceLine() {
    _classCallCheck(this, TraceLine);

    return _possibleConstructorReturn(this, _getPrototypeOf(TraceLine).apply(this, arguments));
  }

  _createClass(TraceLine, [{
    key: "render",
    value: function render() {
      var _this = this;

      return React.createElement("li", {
        className: style.line
      }, React.createElement("p", null, React.createElement("span", {
        className: style.file
      }, this.props.file || '<<closure>>'), React.createElement("span", {
        className: style.line
      }, this.props.line ? ' - line ' + this.props.line + ': ' : '')), React.createElement("p", {
        className: style.call
      }, this.props.class, this.props.type, this.props.function, "(", this.props.args ? this.props.args.map(function (arg, i) {
        return [React.createElement(Argument, {
          key: i,
          data: arg
        }), i < _this.props.args.length - 1 ? ', ' : ''];
      }) : [], ")"));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return TraceLine;
}(Component);
export var Argument =
/*#__PURE__*/
function (_Component2) {
  _inherits(Argument, _Component2);

  function Argument() {
    var _getPrototypeOf2;

    var _this2;

    _classCallCheck(this, Argument);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Argument)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this2), "state", {
      show: false
    });

    _defineProperty(_assertThisInitialized(_this2), "toggle", function () {
      _this2.setState({
        show: !_this2.state.show
      });
    });

    return _this2;
  }

  _createClass(Argument, [{
    key: "render",
    value: function render() {
      var baseFormatted = formatArgument(this.props.data);
      var fancyFormatted = formatArgument(this.props.data, 4);
      var showInline = baseFormatted.length < 32;
      return React.createElement("span", {
        className: style.argument,
        title: showInline ? null : fancyFormatted
      }, showInline ? baseFormatted : "".concat(baseFormatted.substr(0, 12), " ... ").concat(baseFormatted.substr(baseFormatted.length - 2, 2)));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return Argument;
}(Component);
export function formatArgument(data, whitespace) {
  var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var leadingSpace = ' '.repeat(whitespace * depth);

  if (data && data.__class__) {
    var className = data['__class__'],
        copy = _objectWithoutProperties(data, ["__class__"]);

    return "".concat(leadingSpace).concat(className, " ").concat(formatArgument(copy, whitespace, depth).trim());
  } else if (Array.isArray(data)) {
    if (data.length === 0) {
      return "".concat(leadingSpace, "[]");
    }

    return "".concat(leadingSpace, "[\n").concat(data.map(function (value) {
      return formatArgument(value, whitespace, depth + 1);
    }).join(whitespace ? ',\n' : ',')).concat(whitespace ? '\n' : '').concat(leadingSpace, "]");
  } else if (data !== null && _typeof(data) === 'object') {
    if (Object.keys(data).length === 0) {
      return "".concat(leadingSpace, "{}");
    }

    var keyWhitespace = ' '.repeat(whitespace * (depth + 1));
    return "".concat(leadingSpace, "{\n").concat(Object.keys(data).map(function (key) {
      return "".concat(keyWhitespace).concat(key, ": ").concat(formatArgument(data[key], whitespace, depth + 1).trim());
    }).join(whitespace ? ',\n' : ',')).concat(whitespace ? '\n' : '').concat(leadingSpace, "}");
  } else {
    return leadingSpace + JSON.stringify(data, null, whitespace);
  }
}
;

(function () {
  var reactHotLoader = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).default;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(TraceLine, "TraceLine", "/srv/http/owncloud/apps/logreader/js/Components/TraceLine.js");
  reactHotLoader.register(Argument, "Argument", "/srv/http/owncloud/apps/logreader/js/Components/TraceLine.js");
  reactHotLoader.register(formatArgument, "formatArgument", "/srv/http/owncloud/apps/logreader/js/Components/TraceLine.js");
})();

;

(function () {
  var leaveModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).leaveModule;
  leaveModule && leaveModule(module);
})();